__webpack_require__.p = "/Quix_News_Admin/";